/* eslint-disable react/prop-types */
import { useState, useEffect, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import "./Home.css";
import { encryptPayload } from "../../utils/cryptoUtils";

function StatDS({ component, viewId, currentUser }) {
  const [isLoading, setIsLoading] = useState(true);
  const [iframeUrl, setIframeUrl] = useState(null);
  const [encryptionError, setEncryptionError] = useState(null);

  const payloadData = useMemo(
    () => ({
      userId: currentUser?.uid || "anonymous",
      viewId: viewId,
      timestamp: Date.now(),
      componentId: component?.id || null,
      datasetId: component.content || null,
    }),
    [component, viewId, currentUser]
  );

  useEffect(() => {
    let isCancelled = false;

    const generateEncryptedUrl = async () => {
      try {
        setIsLoading(true);
        setEncryptionError(null);
        const encryptedPayload = await encryptPayload(payloadData);
        if (isCancelled) return;

        if (!encryptedPayload) {
          throw new Error("Failed to generate encrypted payload.");
        }

        const streamlitUrl = `https://datasculpture.streamlit.app/?embed=true&statid=${encryptedPayload}`;
        console.log("🔐 StatDS - Generated Streamlit URL:", streamlitUrl);
        setIframeUrl(streamlitUrl);
      } catch (error) {
        console.error("🔐 StatDS - Encryption failed:", error);
        if (!isCancelled) {
          setEncryptionError(error.message || "Encryption failed");
          setIframeUrl(null);
        }
      } finally {
        if (!isCancelled) {
          setIsLoading(false);
        }
      }
    };

    generateEncryptedUrl();

    return () => {
      isCancelled = true;
    };
  }, [payloadData]);

  const { getRootProps, getInputProps } = useDropzone({
    noClick: true,
    noKeyboard: true,
    onDrop: (acceptedFiles) => {
      console.log("Dropzone file accepted: ", acceptedFiles);
      // Handle file processing here
    },
    accept: {
      "application/pdf": [],
      "text/csv": [],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
      "application/json": [],
    },
  });

  if (isLoading) {
    return null;
  }

  if (encryptionError) {
    return (
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        <div style={{ padding: "1rem", color: "red" }}>Unable to encrypt payload securely. Please try again later.</div>
      </div>
    );
  }

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <div>
        <iframe
          src={iframeUrl}
          style={{
            width: "100%",
            height: "100vh",
            border: "0px",
          }}
          title="Statistics Dashboard"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-modals"
          allow="fullscreen"
        />
      </div>
    </div>
  );
}

export default StatDS;
